import React from "react";
import { NetworkHelpers as Network } from "./";
import { MembershipPackagePrice, MembershipAddToBasketButton, CompareMemberships } from "../components/common/transactions";

export function setMembershipPackageTemplate( productId, premium, renderSmall, onPromo, price, network, inCart, onAddToCartClicked, handleCompare ) {
    switch( productId ) {
        case 1: return renderPremiumPackage( productId, premium, renderSmall, onPromo, price, network, inCart, onAddToCartClicked, handleCompare );
        // case 2: return renderPlatinumPackage( productId, premium, renderSmall, onPromo, price, network, inCart, onAddToCartClicked, handleCompare );
        // case 3: return renderPlatinumPackage( productId, premium, renderSmall, onPromo, price, network, inCart, onAddToCartClicked, handleCompare );
        // case 4: return renderPlatinumPackage( productId, premium, renderSmall, onPromo, price, network, inCart, onAddToCartClicked, handleCompare );
        // case 5: return renderPlatinumPackage( productId, premium, renderSmall, onPromo, price, network, inCart, onAddToCartClicked, handleCompare );
        case 6: return renderGoldPackage( productId, premium, renderSmall, onPromo, price, network, inCart, onAddToCartClicked, handleCompare );
        case 7: return renderPlatinumPackage( productId, premium, renderSmall, onPromo, price, network, inCart, onAddToCartClicked, handleCompare );
        default: return false;
    }
}

function renderPremiumPackage( productId, premium, renderSmall, onPromo, price, network, inCart, onAddToCartClicked, handleCompare ) {
    const networkTitle = Network.setNetworkTitle( network );
    return (
        <li className={ `package${ premium === true  ? ' super-premium recommended' : '' }` }>
            <h2 classname="h2">Premium</h2>
            <h6 className="h6 ">{ networkTitle }</h6>
            {
                renderSmall && <p className={ premium === true  ? 'white' : '' }>New to a portfolio career? Our single network membership plan is a great place to get started if you’re just dipping your toe in the water.</p>
            }
            <MembershipPackagePrice basePrice={ price } promoPrice={ onPromo && onPromo } />
            <div className="btn-reposition">
                <MembershipAddToBasketButton
                    network={ network }
                    inCart={ inCart }
                    productId={ productId }
                    premium={ premium }
                    onAddToCartClicked={ onAddToCartClicked }
                />
            </div>
            {
                !renderSmall && premiumPackageDetails( productId, premium, network, inCart, onAddToCartClicked )
            }
            {
                renderSmall && <CompareMemberships handleCompare={ handleCompare } renderSmall={ renderSmall } />
            }
        </li>
    );
}

function renderGoldPackage( productId, premium, renderSmall, onPromo, price, network, inCart, onAddToCartClicked, handleCompare ) {
    return (
        <li className={ `package${ premium === true  ? ' super-premium recommended' : '' }` }>
            <h2 classname="h2">Gold</h2>
            <h6 className="h6 ">All networks</h6>
            {
                renderSmall && <p  className={ premium === true  ? 'white' : '' }> For those looking to build a diverse portfolio of appointments on a global scale. Access to all In Touch Networks + free evening networking events.</p>
            }
            <MembershipPackagePrice basePrice={ price } promoPrice={ onPromo && onPromo } />
            <div className="btn-reposition-center">
                <MembershipAddToBasketButton
                    network={ network }
                    inCart={ inCart }
                    productId={ productId }
                    onAddToCartClicked={ onAddToCartClicked }
                />
            </div>
            {
                !renderSmall && goldPackageDetails( productId, premium, network, inCart, onAddToCartClicked )
            }
            {
                renderSmall && <CompareMemberships handleCompare={ handleCompare } renderSmall={ renderSmall } />
            }
        </li>
    );
}

function renderPlatinumPackage( productId, premium, renderSmall, onPromo, price, network, inCart, onAddToCartClicked, handleCompare ) {
    return (
        <li className={ `package${ premium === true ? ' super-premium recommended' : '' }` }>
            <h2 classname="h2">Platinum</h2>
            <h6 className="h6 ">All networks</h6>
            {
                renderSmall && <p className={ premium === true  ? 'white' : '' }>The entire In Touch Networks platform. For professionals serious about a long-term portfolio career. Platinum is designed to maximise your potential.</p>
            }
            <MembershipPackagePrice basePrice={ price } promoPrice={ onPromo && onPromo } />
            <div className="btn-reposition">
                <MembershipAddToBasketButton
                    network={ network }
                    inCart={ inCart }
                    productId={ productId }
                    onAddToCartClicked={ onAddToCartClicked }
                />
            </div>
            {
                !renderSmall && platinumPackageDetails( productId, premium, network, inCart, onAddToCartClicked )
            }
            {
                renderSmall && <CompareMemberships handleCompare={ handleCompare } renderSmall={ renderSmall } />
            }
        </li>
    );
}

function premiumPackageDetails( productId, premium, network, inCart, onAddToCartClicked ) {
    return (
        <section>
            <ul className="package-includes">
                <li>Profile<br/><span>(Full listing on 1 network)</span></li>
                <li>Jobs Board<br/><span>(Full access on 1 network)</span></li>
                <li>Professional Documents</li>
                <li>News</li>
                <li>Forum<br/><span>(Full access)</span></li>
                <li>Networking</li>
                <li>On-Demand Training<br/><span>(Full access to 60+ online videos)</span></li>
                <li>Email Address<span><br/></span></li>
            </ul>
            <div className="pos-bottom">
                <MembershipAddToBasketButton
                    network={ network }
                    inCart={ inCart }
                    productId={ productId }
                    premium={ premium }
                    onAddToCartClicked={ onAddToCartClicked }
                />
            </div>
        </section>
    );
}

function goldPackageDetails( productId, premium, network, inCart, onAddToCartClicked ) {
    return (
        <section>
            <ul className="package-includes">
                <li>Profile<br/><span>(Full listing on all networks + Business Transformation)</span></li>
                <li>Jobs Board<br/><span>(Full access on all networks)</span></li>
                <li>Professional Documents</li>
                <li>News</li>
                <li>Forum<span><br/>(Full access)</span></li>
                <li>Networking</li>
                <li>On-Demand Training<br/><span>(Full access to 60+ online videos)</span></li>
                <li>Evening Networking Events<br/><span>(Free entry. Subject to availability. Booking required.)</span></li>
                <li>Email Address<span><br/></span></li>
            </ul>
            <div className="pos-bottom">
                <MembershipAddToBasketButton
                    network={ network }
                    inCart={ inCart }
                    productId={ productId }
                    premium={ premium }
                    onAddToCartClicked={ onAddToCartClicked }
                />
            </div>
        </section>
    );
}

function platinumPackageDetails( productId, premium, network, inCart, onAddToCartClicked ) {
    return (
        <section>
            <ul className="package-includes">
                <li>Profile<br/><span>(Full listing on all networks + Business Transformation)</span></li>
                <li>Jobs Board<br/><span>(Full access on all networks)</span></li>
                <li>Professional Documents</li>
                <li>News</li>
                <li>Forum<span><br/>(Full access)</span></li>
                <li>Networking</li>
                <li>On-Demand Training<br/><span>(Full access to 60+ online videos)</span></li>
                <li>Evening Networking Events<br/><span>(Free entry. Subject to availability. Booking required.)</span></li>
                <li>1 Interactive Webinar Series<br/><span>(Subject to availability. Booking required.)</span></li>
                <li>Video Profile<br/><span>(1 hour of studio use)</span></li>
                <li>Professional Photo<br/><span>(30 minutes of studio use)</span></li>
                <li>CV Service<br/><span>(1 CV review)</span></li>
                <li>Psychometrics<br/><span/></li>
                <li>Jobs pre-sale<br/><span/></li>
                <li>Email Address<span><br/></span></li>
            </ul>
            <div className="pos-bottom">
                <MembershipAddToBasketButton
                    network={ network }
                    inCart={ inCart }
                    productId={ productId }
                    premium={ premium }
                    onAddToCartClicked={ onAddToCartClicked }
                />
            </div>
        </section>
    );
}



// WEBPACK FOOTER //
// src/client/helpers/MembershipPlanTemplates.js